(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SF-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const RING_R = 18;
    const CIRC = 2 * Math.PI * RING_R;

    function setRing(ring, progress) {
      if (!ring) return;
      const p = Math.min(1, Math.max(0, progress));
      ring.style.strokeDasharray = String(CIRC);
      ring.style.strokeDashoffset = String(CIRC * (1 - p));
    }

    function destroyRoot(root) {
      if (!root || !root._apCoverflowSwiper) return;
      try {
        root._apCoverflowSwiper.destroy(true, true);
      } catch (e) {}
      root._apCoverflowSwiper = null;
    }

    function initRoot(root) {
      const swiperEl = root.querySelector('.ap-coverflow-slider__swiper');
      if (!swiperEl) return;

      const slideCount = parseInt(root.dataset.slideCount || '0', 10);
      if (slideCount < 1) return;

      destroyRoot(root);

      const durationMs = parseInt(root.dataset.durationMs || '12000', 10);
      const speedMs = parseInt(root.dataset.speedMs || '4000', 10);
      const autoplayOn = root.dataset.autoplay === 'true';
      const ring = root.querySelector('.ap-coverflow-slider__progress-ring');
      const progressWrap = root.querySelector('.ap-coverflow-slider__progress');

      const prevEl = root.querySelector('.ap-coverflow-slider__arrow--prev');
      const nextEl = root.querySelector('.ap-coverflow-slider__arrow--next');
      const pagEl = swiperEl.querySelector('.ap-coverflow-slider__pagination');
      const slideWidth = swiperEl.querySelector('.ap-coverflow-slider__slide').offsetWidth;
      console.log(slideWidth);

      let progressRaf = 0;
      let progressStart = 0;

      function stopProgressLoop() {
        if (progressRaf) {
          cancelAnimationFrame(progressRaf);
          progressRaf = 0;
        }
      }

      function startProgressLoop(totalMs) {
        stopProgressLoop();
        if (slideCount < 2 || !ring || !progressWrap) return;
        if (!autoplayOn) {
          setRing(ring, 0);
          return;
        }
        progressWrap.classList.remove('ap-coverflow-slider__progress--hidden');
        setRing(ring, 0);
        progressStart = performance.now();
        const total = Math.max(500, totalMs);

        function tick(now) {
          const elapsed = now - progressStart;
          const t = Math.min(1, elapsed / total);
          setRing(ring, t);
          if (t < 1) {
            progressRaf = requestAnimationFrame(tick);
          } else {
            progressRaf = 0;
          }
        }
        progressRaf = requestAnimationFrame(tick);
      }

      window.loadSwiper().then((SwiperCtor) => {
        const useLoop = slideCount > 2;
        const useRewind = slideCount > 1 && slideCount <= 3;

        const swiper = new SwiperCtor(swiperEl, {
          slidesPerView: 1,
          speed: 1200,
          loop: useLoop,
          watchSlidesProgress: true,

          navigation:
            prevEl && nextEl
              ? {
                  prevEl,
                  nextEl,
                }
              : false,
          pagination: pagEl
            ? {
                el: pagEl,
                clickable: true,
              }
            : false,
          autoplay:
            autoplayOn && slideCount > 1
              ? {
                  delay: Math.max(500, durationMs),
                  disableOnInteraction: false,
                  waitForTransition: true,
                }
              : false,
          on: {
            init() {
              if (slideCount > 1 && autoplayOn) {
                startProgressLoop(Math.max(500, durationMs));
              }
            },
            slideChangeTransitionEnd() {
              if (slideCount > 1 && autoplayOn) {
                startProgressLoop(Math.max(500, durationMs));
              }
            },
            autoplayStop() {
              stopProgressLoop();
              if (ring) setRing(ring, 0);
            },
            autoplayStart() {
              if (slideCount > 1) startProgressLoop(Math.max(500, durationMs));
            },
            touchStart() {
              stopProgressLoop();
            },
            touchEnd() {
              if (autoplayOn && slideCount > 1 && swiper.autoplay) {
                try {
                  swiper.autoplay.start();
                } catch (e) {}
              }
            },
          },
        });

        root._apCoverflowSwiper = swiper;
      });
    }

    function initAll() {
      document.querySelectorAll('[data-ap-coverflow-root]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (ev) => {
      const r = ev.target && ev.target.querySelector && ev.target.querySelector('[data-ap-coverflow-root]');
      if (r) initRoot(r);
    });

    document.addEventListener('shopify:section:unload', (ev) => {
      const r = ev.target && ev.target.querySelector && ev.target.querySelector('[data-ap-coverflow-root]');
      if (r) destroyRoot(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
